import z from "zod/v4";

export const SessionStatusList = [
  "active",
  "waiting_for_input",
  "waiting_for_tool_approval",
  "processing",
  "completed",
  "continue",
  "error",
  "timeout",
] as const;
export const SessionStatusSchema = z.enum(SessionStatusList);
export type SessionStatus = z.infer<typeof SessionStatusSchema>;

export const WorkflowSessionSchema = z.object({
  sessionId: z.string(),
  workflowId: z.string(),
  orgId: z.string(),
  userId: z.string(),
  currentNodeId: z.string(),
  nextNodeId: z.string(),
  status: SessionStatusSchema,
  contextS3Key: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type WorkflowSession = z.infer<typeof WorkflowSessionSchema>;

export type CreateWorkflowSession = Omit<
  WorkflowSession,
  "orgId" | "userId" | "createdAt" | "updatedAt"
>;
